<template>
    <div class="perfect-info-modal-content">
        <div class="perfect-info-modal-content__hint">根据人社主管部门要求，需要您进入详情完善以下信息</div>
        <div class="perfect-info-modal-content__list clearfix">
            <div
                v-for="(info,index) in modalContent"
                v-show="showContent"
                :key="index"
                class="perfect-info-modal-content__list-item"
            >
                <h4>{{ info.title }}</h4>
                <div
                    v-for="(item,index2) in info.list"
                    :key="index2"
                    :class="getClass(item)"
                >
                    {{ item.title }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import getProjectCompleteness from '@service/project/getProjectCompleteness'

export default {
    name: 'ProjectPerfectInfoModalContent',
    props: {
        record: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            modalContent: [
                {
                    title: '项目信息',
                    list: [
                        {
                            title: '项目基础信息',
                            key: 'projectBaseInfoCnf'
                        },
                        {
                            title: '工程进度',
                            key: 'scheduleCnf'
                        },
                        {
                            title: '施工许可证',
                            key: 'constructPermitCnf'
                        }
                    ]
                },
                {
                    title: '专户信息',
                    list: [
                        {
                            title: '工资支付专户信息',
                            key: 'payrollAmountCnf'
                        },
                        {
                            title: '保证金专户信息',
                            key: 'marginAmountCnf'
                        }
                    ]
                },
                {
                    title: '工程款支付担保',
                    list: [
                        {
                            title: '工程款支付担保',
                            key: 'guaranteeCnf'
                        }
                    ]
                },
                {
                    title: '参建单位',
                    list: [
                        {
                            title: '五方责任主体列表',
                            key: 'responsibleSubjectCnf'
                        },
                        {
                            title: '分包单位列表',
                            key: 'participatingUnitsCnf'
                        }
                    ]
                },
                {
                    title: '班组管理',
                    list: [
                        {
                            title: '班组列表',
                            key: 'teamCnf'
                        }
                    ]
                },
                {
                    title: '考勤工资管理',
                    list: [
                        {
                            title: '考勤工资管理',
                            key: 'attendanceSalaryMonthCnf'
                        }
                    ]
                }
                // {
                //     title: '考勤管理',
                //     list: [
                //         {
                //             title: '考勤管理',
                //             key: 'attendanceMonthCnf'
                //         }
                //     ]
                // },
                // {
                //     title: '工资管理',
                //     list: [
                //         {
                //             title: '工资发放',
                //             key: 'salaryMonthCnf'
                //         }
                //     ]
                // }


            ],
            showContent: false
        }
    },
    watch: {
        record: {
            handler(val) {
                const { projectCode = '' } = val || {}
                if (projectCode) {
                    this.getData(projectCode)
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        getClass(item) {
            return `perfect-info-modal-content__list-item-${item.finish ? 'success' : 'warn'}`
        },
        async getData(projectCode) {
            try {
                const result = await getProjectCompleteness({
                    projectCode
                })
                this.formatModalContent(result)
            } catch (error) {
                this.$message.warning(error.message)
            }
        },
        formatModalContent(result) {
            let { modalContent } = this
            modalContent.forEach(box => {
                for (let i = 0; i < box.list.length; i++) {
                    box.list[i].finish = result[box.list[i].key]
                }
            })
            this.modalContent = {
                ...modalContent
            }
            this.showContent = true
        }
    }

}
</script>

<style lang="scss">
@import '@assets/styles/varibles.scss';

.perfect-info-modal-content {
    &__hint {
        color: #848b91;
        text-align: center;
        font-size: 14px;
        margin-bottom: $space-sm;
        letter-spacing: 2px;
    }
    &__list {
        min-height: 135px;
        &-item {
            float: left;
            width: 104px;
            min-height: 135px;
            background: #fff;
            border: 1px solid #dcdee0;
            padding: $space-sm 5px 0 5px;
            &-success {
                background-color: #edffed;
                color: #0b8e2b;
                background-image: url('~@/assets/images/icon/success.png');
            }
            &-warn {
                background-color: #fff7e6;
                color: #ef7400;
                background-image: url('~@/assets/images/icon/warn.png');
            }
            &:not(:last-child) {
                margin-right: $space-sm;
            }
            > h4 {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                color: #323233;
                margin-bottom: $space-sm;
                text-align: center;
            }
            > div {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                line-height: 13.5px;
                border-radius: 19px;
                padding: 5px 0 5px 26px;
                background-repeat: no-repeat;
                background-size: 12px;
                background-position: 6px center;
                &:not(:last-child) {
                    margin-bottom: 4px;
                }
            }
        }
    }
}
</style>
